import { render, staticRenderFns } from "./NewsCardHome.vue?vue&type=template&id=2f31af66&scoped=true&"
import script from "./NewsCardHome.vue?vue&type=script&lang=js&"
export * from "./NewsCardHome.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardHome.vue?vue&type=style&index=0&id=2f31af66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f31af66",
  null
  
)

export default component.exports